import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {GameCategory} from '@lbsdk/*';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'threshold-reward-form',
  templateUrl: './threshold-reward-form.component.html',
  styleUrls: ['./threshold-reward-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ThresholdRewardFormComponent implements OnInit {
  dialogTitle: string;
  thresholdRewardForm: FormGroup;
  action: string;
  thresholdRewardData: any;

  constructor(public dialogRef: MatDialogRef<ThresholdRewardFormComponent>,
              @Inject(MAT_DIALOG_DATA) private data: any,
              private formBuilder: FormBuilder) {
    this.action = data.action;
    this.dialogTitle = 'Threshold Reward';

    if ( this.action === 'edit' ) {
      this.thresholdRewardData = data.thresholdRewardData;
    }
    else {
      this.thresholdRewardData = {};
    }

    this.thresholdRewardForm = this.createThresholdRewardForm();
  }

  ngOnInit() {
  }

  createThresholdRewardForm()
  {
    return this.formBuilder.group({
      name: [this.thresholdRewardData.name],
      points: [this.thresholdRewardData.points],
      image: [this.thresholdRewardData.image],
      counter: [this.thresholdRewardData.counter]
    });
  }
}
